import React from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { Header } from './Header';
import { useAuth } from '../auth/AuthProvider';

export function Layout(): React.ReactElement {
  const { status, signIn } = useAuth();
  const navigate = useNavigate();

  if (status === 'loading') {
    return (
      <div className="flex items-center justify-center h-screen">
        <p className="text-text-secondary">Loading…</p>
      </div>
    );
  }

  if (status === 'unauthenticated') {
    return (
      <div className="flex items-center justify-center h-screen">
        <div className="text-center space-y-4">
          <h1 className="text-2xl font-bold text-text-primary">OutLinked Admin</h1>
          <p className="text-text-secondary">Sign in with your admin account to continue.</p>
          <button
            onClick={() => {
              void signIn();
              void navigate('/');
            }}
            className="px-6 py-2 bg-brand-600 text-white rounded-md hover:bg-brand-700 focus:outline-none focus:ring-2 focus:ring-brand-500"
          >
            Sign in
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="flex h-screen overflow-hidden">
      <Sidebar />
      <div className="flex flex-col flex-1 overflow-hidden">
        <Header />
        <main className="flex-1 overflow-auto p-6">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
